import componentMixin from "./component-mixin.js";
import httpMixin from "./http-mixin.js";
import httpService from "../services/http-service";
import Bus from "../services/bus.js";

// Handles HTTP Inputs
export default {
  mixins: [componentMixin, httpMixin],
  // data => données chargées partiellement
  // dataloaded => timestamp de la donnée chargée

  data() {
    return { objectData: new Object(), timeEnd: 0, watchYAxis: "" };
  },
  mounted() {
    this.prepare();
    this.prepareObjectData();
    this.clear();
    // for static histogram , we use an attribute 'illustration' in xml.
    // static is an histogram wich is not dependant on the observation: Abaqus for example
    if (this.attributes.illustration) {
      this.componentStartEvent();

      this.D3prepareYAxis(this.getFluxStructure(this.flux_identifier));
      let i = 0;
      this.watchYAxis = setInterval(
        () => {
          if (this.yAxis) {
            this.getStaticDataForFlux(this.flux_identifier, 0 + i, i).then(
              () => {}
            );
            i = i + 100;
            this.tick();
          } else {
            console.log(this.yAxis);
          }
        },
        100,
        this
      );
    }

    Bus.$on("ireal-start", async () => {
      if (!this.attributes.illustration) {
        this.clear();
        this.componentStartEvent();
        this.getData().then(() => {});
      }
    });
  },
  methods: {
    stopWatchYAxis() {
      clearInterval(this.watchYAxis);
    },
    clear() {
      this.dom_canvas == undefined
        ? ""
        : this.dom_canvas.selectAll("path").remove();
      // The old ordinate scale is removed:
      this.dom_canvas == undefined
        ? ""
        : this.dom_canvas.selectAll(".dom_yAxis").remove();
      // Remove old grid pattern:
      this.dom_canvas == undefined
        ? ""
        : this.dom_canvas.selectAll(".grid").remove();
      this.resetData();
    },
    componentStartEvent() {},
    getTimeData(params) {
      this.httpHandler(
        httpService.client.get(
          `observation/get_time_data/${this.getParamStr(params)}`
        )
      ).then((result) => {
        this.writeTimeEnd(result.time_end);
        this.writeTimeStart(result.time_start);
        return result;
      });
    },
    getFluxStructure(flux_identifier, flux_label) {
      if (flux_label === undefined) {
        flux_label === undefined;
      }
      if (typeof this.objectData[flux_identifier] === "undefined") {
        this.objectData[flux_identifier] = {
          data: [],
          dataLoaded: -1,
          loading: false,
          name: flux_identifier,
          label: flux_label,
        };
      }
      return this.objectData[flux_identifier];
    },
    // in order to begin a new graphik with a  new parameter, we reset previous data
    resetData() {
      //console.log("object data", this.objectData);
      Object.keys(this.objectData).forEach((flux_identifier) => {
        let flux_structure = this.getFluxStructure(flux_identifier);
        flux_structure.data = [];
        flux_structure.dataLoaded = -1;
        this.prepareFlux(flux_structure);
      }, this);
      this.yAxis = {};
      this.writeTimeEnd(0);
    },

    writeTimeEnd(time) {
      this.timeEnd = time;
    },
    writeTimeStart(time) {
      this.timeStart = time;
    },
    prepareFlux() {},
    // load data from server
    getStaticDataForFlux(flux_identifier, start_time, progress) {
      let flux_structure = this.getFluxStructure(flux_identifier);
      const bufferSize = 100;
      const start = this.timeStart + flux_structure.dataLoaded + 1;

      const end = this.timeStart + progress + bufferSize;
      if (this.timeEnd && end > this.timeEnd + bufferSize / 2) {
        this.stopWatchYAxis();
      }

      let params = {
        params: { test: "test" },
        start,
        end,
        flux_identifier,
        experience_id: this.$store.getters.experience.id,
        seed: this.$store.getters.seed,
      };
      let promise;
      if (
        end >= this.timeStart + progress + bufferSize / 2 &&
        flux_structure.loading === false &&
        !isNaN(this.timeStart) &&
        !isNaN(this.timeEnd)
      ) {
        flux_structure.loading = true;
        promise = this.getObjectList("observation_data/by_params", params)
          .then((data) => {
            if (this.update && data.length > 1) {
              flux_structure.data = data;
              flux_structure.dataLoaded = end - this.timeStart;
              flux_structure.loading = false;
            } else {
              flux_structure.data = flux_structure.data.concat(data);
              flux_structure.dataLoaded = end - this.timeStart;
              flux_structure.loading = false;
            }

            return data;
          })
          .catch(() => {
            flux_structure.loading = false;

            // indicates to the store that datas for illustration is ok so stop the tick() in irealviewer
            this.$store.commit("stop_illustration");
          });
      } else promise = Promise.resolve([]);
      return promise;
    },
    // load data from server
    getDataForFlux(flux_identifier) {
      let flux_structure = this.getFluxStructure(flux_identifier);
      // TODO: make buffer size configurable
      const bufferSize = 100;
      const start = this.timeStart + flux_structure.dataLoaded + 1;

      const end = this.timeStart + this.progress + bufferSize;

      let params = {
        params: this.$store.getters.testParams,
        start,
        end,
        flux_identifier,
        experience_id: this.$store.getters.experience.id,
        seed: this.$store.getters.seed,
      };
      let promise;
      if (
        end >= this.timeStart + flux_structure.dataLoaded + bufferSize / 2 &&
        flux_structure.loading === false &&
        !isNaN(start) &&
        !isNaN(end)
      ) {
        flux_structure.loading = true;
        promise = this.getObjectList("observation_data/by_params", params)
          .then((data) => {
            if (this.update && data.length > 1) {
              flux_structure.data = data;
              flux_structure.dataLoaded = end - this.timeStart;
              flux_structure.loading = false;
            } else {
              flux_structure.data = flux_structure.data.concat(data);
              flux_structure.dataLoaded = end - this.timeStart;
              flux_structure.loading = false;
            }
            return data
          })
          .catch(() => {
            flux_structure.loading = false;
          });
      } else promise = Promise.resolve([]);

      return promise;
    },
    prepareObjectData() {
      for (var i = 0; i < this.flux_definition.length; i++) {
        let flux_structure = this.getFluxStructure(this.flux_definition[i]);
        flux_structure.attributes = this.config.elements[i].attributes;
      }
    },
    getData() {
      let promises = [];
      if (this.attributes.illustration) {
        for (var j = 0; j < this.flux_definition.length; j++) {
          let promise = this.getStaticDataForFlux(this.flux_definition[j]);
          promises.push(promise);
        }
      } else {
        for (var i = 0; i < this.flux_definition.length; i++) {
          let promise = this.getDataForFlux(this.flux_definition[i]);

          promises.push(promise);
        }
      }

      // retourne toutes les promesses, lorsqu'elles sont toutes résolues. Sinon, le mounted subira une erreur au niveau du then
      return Promise.all(promises);
    },
    getObservationVideo() {
      const params = {
        params: this.$store.getters.testParams,
        flux_identifier: this.flux_identifier,
        experience_id: this.$store.getters.experience.id,
        seed: this.$store.getters.seed,
      };
      return this.httpHandler(
        httpService.client.get(
          `observation_video/by_params/${this.getParamStr(params)}`
        )
      );
    },
    getObservationVideos(flux_identifier) {
      const params = {
        params: this.$store.getters.testParams,
        flux_identifier: flux_identifier,
        experience_id: this.$store.getters.experience.id,
        seed: this.$store.getters.seed,
      };
      return this.httpHandler(
        httpService.client.get(
          `observation_video/by_params/${this.getParamStr(params)}`
        )
      );
    },
    getNewObservationVideo(payload) {
      const params = {
        params: this.$store.getters.testParams,
        flux_identifier: payload,
        experience_id: this.$store.getters.experience.id,
        seed: this.$store.getters.seed,
      };
      return this.httpHandler(
        httpService.client.get(
          `observation_video/by_params/${this.getParamStr(params)}`
        )
      );
    },
    createExperience() {
      httpService.client.get(`experience/put_experience/`);
    },
  },
  computed: {
    flux() {
      return this.attributes.flux || "";
    },
    flux_identifier() {
      let result;
      // une experiencetype peut recevoir plusieurs flux ( ex.: pour plusieurs courbes).
      // par défaut, nous prenons que le premier élément du tableau de flux.
      // nous recupérons l'attribut "name" de la balise <flux> du layout pour obtenir le nom de l'experience_flux rattachée
      try {
        result = this.config.elements[0].attributes.name;
      } catch (e) {
        result = "";
      }
      //return this.attributes.flux;
      return result;
    },
    flux_definition() {
      let flux_definition = [];
      if (this.config.elements) {
        this.config.elements.forEach(function (element) {
          flux_definition.push(element.attributes.name);
        });
      }

      return flux_definition;
    },
    Is_data_abscisse() {
      return this.attributes.data_x;
    },
    Is_message_to_show() {
      return this.attributes.text;
    },
    // by default graph has just one scaleY
    //but graph can have 2 scaleY with hte attributes 'double_ordonnee' in Histogram tag
    bisect_tooltip() {
      return this.attributes.bisect;
    },
    Is_histogram_plot() {
      return this.attributes.plot;
    },
    legend_x() {
      return this.attributes.legend_x;
    },
    time_range() {
      return this.timeEnd ? parseFloat(this.timeEnd) : 0;
    },
    model_poster() {
      return this.config.elements[0].attributes.poster;
    },
    title_component() {
      return this.attributes.title_component || "";
    },
    pointer_event() {
      return this.attributes.pointer_event || "none";
    },
    update() {
      return this.attributes.update || "";
    },
  },
};
